import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ArrowDownRight = createReactComponent("ArrowDownRight", ["svg", defaultAttributes, [["line", {
  x1: "7",
  y1: "7",
  x2: "17",
  y2: "17",
  key: "s6w834"
}], ["polyline", {
  points: "17 7 17 17 7 17",
  key: "9dq2ur"
}]]]);
export default ArrowDownRight;